module.exports = __webpack_public_path__ + "static/img/runner.5df10850.svg";